import React from 'react';
import API from '../../../utils/API';
import FieldModal from '../../../components/modals/fieldModal';

class CloseFormNowModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = { submitting: false };
    }

    closeFormNow = async () => {
        const { orgId, formId, isFormClosed, updateCloseStatus, toggle } = this.props;
        this.setState({ submitting: true });
        await API()
            .patch(`Organizations/${orgId}/accountForms/${formId}/close`, { closed: !isFormClosed })
            .then(() => {
                this.setState({ submitting: false });
                updateCloseStatus({ closed: !isFormClosed, closeAt: null }, toggle);
            })
            .catch(() => this.setState({ submitting: false }));
    };

    render() {
        const { isOpen, toggle, isFormClosed } = this.props;
        const { submitting } = this.state;
        return (
            <FieldModal
                size="small"
                isOpen={isOpen}
                modalTitle={isFormClosed ? 'Open Form Now' : 'Close Form Now'}
                bodyHeaderText={
                    isFormClosed
                        ? 'Are you sure you want to open this form now?'
                        : 'Are you sure you want to close this form now?'
                }
                bodyContent={() => <div />}
                toggle={toggle}
                actionButtonLabel={submitting ? 'Submitting...' : 'Submit'}
                cancelButtonLabel="Cancel"
                actionButton={this.closeFormNow}
                submitting={submitting}
                actionButtonDisabled={submitting}
            />
        );
    }
}

export default CloseFormNowModal;
